import React, { useEffect, useState } from 'react'
import { useAlert } from 'react-alert'
import { useDispatch, useSelector } from 'react-redux'
import {  useNavigate} from 'react-router-dom'
import { Header, Loader } from '../components'
import { useStateContext } from '../contexts/ContextProvider'
import { userLogin } from '../redux/authentication/authAction'
import { clearErrors } from '../redux/authentication/authSlice'

const Login = () => {
    const [email, setEmail] = useState('admin1@fyp.com')
    const [password, setPassword] = useState('admin1')
    const dispatch = useDispatch()
    const alert = useAlert()
    let navigate = useNavigate()

    const { error, loading, isAuthenticated } = useSelector((state) => state.auth)

    const { currentColor } = useStateContext()
    const handleLogin = (e) => {
        e.preventDefault()
        dispatch(userLogin({ email, password }))
    }

    useEffect(() => {
        console.log("use effect ran of login page")
        if (error) {

            alert.error(error)
            dispatch(clearErrors())
            console.log("error encountered")
        }
        if (isAuthenticated) {
            console.log("entered is Authenticated")

            navigate('/dashboard')

        }
    }, [error, isAuthenticated, dispatch,alert,navigate])


    return (
        loading ? <Loader /> :
            <div className='m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl'>
                <Header category="Login" title="please login" />
                <section className="h-screen">
                    <div className="container px-6 py-12 h-full">
                        <div className="flex justify-center items-center flex-wrap h-full g-6 text-gray-800">
                            <div className="md:w-8/12 lg:w-6/12 mb-12 md:mb-0">
                                <img
                                    src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.svg"
                                    className="w-full"
                                    alt="Phone image"
                                />
                            </div>
                            <div className="md:w-8/12 lg:w-5/12 lg:ml-20">
                                <form onSubmit={handleLogin}>
                                    <div className="mb-6">
                                        <input
                                            type="email"
                                            className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                            placeholder="Email address"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-6">
                                        <input
                                            type="password"
                                            className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                            placeholder="Password"
                                            minLength={5}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />

                                    </div>

                                    <div className="flex justify-center mb-6">

                                        <a
                                            href="#!"
                                            className="text-blue-600 hover:text-blue-700 focus:text-blue-700 active:text-blue-800 duration-200 transition ease-in-out"
                                        >Forgot password?</a
                                        >
                                    </div>

                                    <button
                                        type="submit"
                                        className="inline-block px-7 py-3  text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out w-full"
                                        data-mdb-ripple="true"
                                        data-mdb-ripple-color="light"
                                        style={{ background: currentColor }}

                                    >
                                        Sign in
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
    )
}

export default Login